import { useSelector } from 'react-redux';
import { selectors, sliceKeys } from '../../model';
import { useHousesQuery, housesSelectors } from '../../api/houses';
import { getBaseOptions } from './helpers';

const selectCompanyId = selectors[sliceKeys.companies].selectCurrentId;
const selectCityId = selectors[sliceKeys.cities].selectCurrentId;

const dataTypes = {
  original: 'original',
  groupedByStreet: 'groupedByStreet',
  ids: 'ids',
};

const _options = {
  [dataTypes.original]: { select: housesSelectors.filterByAcceptanceCount },
  [dataTypes.groupedByStreet]: { select: housesSelectors.groupByStreet },
  [dataTypes.ids]: { select: housesSelectors.selectHouseIds },
};

export const useHousesData = ({ options, dataType } = {}) => {
  const companyId = useSelector(selectCompanyId);

  const cityId = useSelector(selectCityId);

  const baseOptions = getBaseOptions(_options, dataType, dataTypes.original);

  return useHousesQuery({
    params: { companyId, cityIds: cityId ? [cityId] : [] },
    options: { ...baseOptions, ...options },
  });
};

useHousesData.dataTypes = dataTypes;
